export default __webpack_public_path__ + "static/media/FAQ_6_3.02068a48.png";